import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, ListGroup, ListGroupItem, Badge } from "reactstrap";
import { assignDiscountCodesToPartner, removeDiscountCodesFromPartner } from "../actions/partners";
import LoadingProgress from "../components/LoadingProgress";

class PartnerDiscountManager extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedCodes: [],
    };
  }

  componentDidMount() {
    // No need to fetch codes - they come from props
  }

  componentDidUpdate(prevProps) {
    // No need to fetch codes - they come from props
  }

  handleCodeSelect = (codeId) => {
    const { selectedCodes } = this.state;
    const isSelected = selectedCodes.includes(codeId);

    if (isSelected) {
      this.setState({
        selectedCodes: selectedCodes.filter(id => id !== codeId)
      });
    } else {
      this.setState({
        selectedCodes: [...selectedCodes, codeId]
      });
    }
  };

  handleAssignCodes = async () => {
    const { partner, assignDiscountCodesToPartner, onClose } = this.props;
    const { selectedCodes } = this.state;

    if (selectedCodes.length === 0) return;

    try {
      await assignDiscountCodesToPartner(partner._id, { discountCodeIds: selectedCodes });
      this.setState({ selectedCodes: [] });
      onClose();
    } catch (error) {
      console.error('Error assigning codes:', error);
    }
  };

  handleRemoveCode = async (codeId) => {
    const { partner, removeDiscountCodesFromPartner } = this.props;

    try {
      await removeDiscountCodesFromPartner(partner._id, { discountCodeIds: [codeId] });
    } catch (error) {
      console.error('Error removing code:', error);
    }
  };

  formatDiscountValue(code) {
    if (code.discountType === 'PERCENTAGE') {
      return `${code.discountValue}%`;
    } else {
      return `€${code.discountValue}`;
    }
  }

  render() {
    const { isOpen, onClose, partner, discountCodes } = this.props;
    const { selectedCodes } = this.state;

    if (!partner) return null;

    // Get assigned codes (codes assigned to this partner)
    const assignedCodes = discountCodes ? discountCodes.filter(code => {
      const assignedPartnerId = code.assigned_partner_id?._id || code.assigned_partner_id;
      return assignedPartnerId === partner._id;
    }) : [];
    
    // Get available codes (codes for the same customer that are not assigned to any partner or assigned to a different partner)
    const availableCodes = discountCodes ? discountCodes.filter(code => {
      const codeCustomerId = code.customer_id?._id || code.customer_id;
      const partnerCustomerId = partner.customer_id?._id || partner.customer_id;
      const assignedPartnerId = code.assigned_partner_id?._id || code.assigned_partner_id;
      
      // Code belongs to same customer and is not assigned to this partner
      return codeCustomerId === partnerCustomerId && assignedPartnerId !== partner._id;
    }) : [];

    return (
      <Modal isOpen={isOpen} toggle={onClose} size="lg">
        <ModalHeader toggle={onClose}>
          Gestionar Códigos de Descuento - {partner.name}
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-6">
              <h5>Códigos Asignados</h5>
              {assignedCodes.length > 0 ? (
                <ListGroup>
                  {assignedCodes.map((code) => (
                    <ListGroupItem key={code._id} className="d-flex justify-content-between align-items-center">
                      <div>
                        <strong>{code.code}</strong> - {this.formatDiscountValue(code)}
                        {code.isActive ? (
                          <Badge color="success" className="ml-2">Activo</Badge>
                        ) : (
                          <Badge color="danger" className="ml-2">Inactivo</Badge>
                        )}
                      </div>
                      <Button
                        color="danger"
                        size="sm"
                        onClick={() => this.handleRemoveCode(code._id)}
                      >
                        <i className="fas fa-trash"></i>
                      </Button>
                    </ListGroupItem>
                  ))}
                </ListGroup>
              ) : (
                <p className="text-muted">No hay códigos asignados</p>
              )}
            </div>

            <div className="col-md-6">
              <h5>Códigos Disponibles</h5>
              {availableCodes.length > 0 ? (
                <ListGroup style={{ maxHeight: '400px', overflowY: 'auto' }}>
                  {availableCodes.map((code) => (
                    <ListGroupItem
                      key={code._id}
                      className={`d-flex justify-content-between align-items-center ${
                        selectedCodes.includes(code._id) ? 'bg-light' : ''
                      }`}
                      style={{ cursor: 'pointer' }}
                      onClick={() => this.handleCodeSelect(code._id)}
                    >
                      <div>
                        <strong>{code.code}</strong> - {this.formatDiscountValue(code)}
                        {code.isActive ? (
                          <Badge color="success" className="ml-2">Activo</Badge>
                        ) : (
                          <Badge color="danger" className="ml-2">Inactivo</Badge>
                        )}
                      </div>
                      <input
                        type="checkbox"
                        checked={selectedCodes.includes(code._id)}
                        onChange={() => this.handleCodeSelect(code._id)}
                      />
                    </ListGroupItem>
                  ))}
                </ListGroup>
              ) : (
                <p className="text-muted">No hay códigos disponibles</p>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={this.handleAssignCodes}
            disabled={selectedCodes.length === 0}
          >
            Asignar {selectedCodes.length} código{selectedCodes.length !== 1 ? 's' : ''}
          </Button>
          <Button color="secondary" onClick={onClose}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  // discountCodes comes from props now
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      assignDiscountCodesToPartner,
      removeDiscountCodesFromPartner,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(PartnerDiscountManager);